module.exports = __webpack_public_path__ + "static/home-hero-mobile.dcdcf9bd.webp";